/**
 *
 * Asynchronously loads the component for VideoRecordingPopover
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
